import { Currency } from "@redotech/money/currencies";
import { getCurrencyFormatter } from "@redotech/money/util";

export function formatPriceAdjustment(
  priceAdjustment: number,
  currency: Currency,
) {
  const fullFormattedPriceAdjustment = getCurrencyFormatter(currency).format(
    Math.abs(priceAdjustment),
  );

  let formattedPriceAdjustment = fullFormattedPriceAdjustment;
  // Truncate ".00" (e.g. "$1.00" => "$1")
  if (
    formattedPriceAdjustment.substring(formattedPriceAdjustment.length - 3) ===
    ".00"
  ) {
    formattedPriceAdjustment = formattedPriceAdjustment.substring(
      0,
      formattedPriceAdjustment.length - 3,
    );
  }
  return { formattedPriceAdjustment, fullFormattedPriceAdjustment };
}
